<template>
    <div>
        <v-btn
            append-icon="mdi-menu-down"
            rounded
        >
            <v-icon :class="current_language_flag" />
        </v-btn>
        <v-menu activator="parent">
            <v-list>
                <v-list-item
                    v-for="(country, language) in languages"
                    :key="language"
                    @click="set_language(language)"
                >
                    <template #prepend>
                        <span
                            :class="flag_class(country)"
                            class="mr-4"
                        />
                    </template>
                    {{ flag_translation(language) }}
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import { setLocale } from '@/plugins/i18n'
import '/node_modules/flag-icons/css/flag-icons.min.css'
import { locales_mixin } from '@old/mixins/locales_mixin'

export default {
    name: 'Language',
    props: {},
    mixins: [locales_mixin],
    components: {},
    data() {
        return {
            languages: {
                'en': 'gb',
                'sv': 'se',
                'am': 'et',
                'ar': 'sa',
                'az': 'az',
                'bg': 'bg',
                'bn': 'bd',
                'bs': 'ba',
                'ceb': 'ph',
                'cs': 'cz',
                'da': 'dk',
                'de': 'de',
                'el': 'gr',
                'es': 'es',
                'et': 'ee',
                'fa': 'ir',
                'fi': 'fi',
                'fr': 'fr',
                'hi': 'in',
                'hr': 'hr',
                'hu': 'hu',
                'hy': 'am',
                'id': 'id',
                'ig': 'ng',
                'is': 'is',
                'it': 'it',
                'ja': 'jp',
                'jw': 'id',
                'ka': 'ge',
                'kk': 'kz',
                'km': 'kh',
                'ko': 'kr',
                'ku': 'iq',
                'lt': 'lt',
                'lv': 'lv',
                'mg': 'mg',
                'mk': 'mk',
                'ml': 'in',
                'mr': 'in',
                'ms': 'my',
                'my': 'mm',
                'ne': 'np',
                'nl': 'nl',
                'no': 'no',
                'ny': 'mw',
                'pa': 'pk',
                'pl': 'pl',
                'ps': 'af',
                'pt': 'pt',
                'ro': 'ro',
                'ru': 'ru',
                'sd': 'pk',
                'si': 'lk',
                'sk': 'sk',
                'sl': 'sl',
                'so': 'so',
                'sq': 'al',
                'sr': 'sr',
                'su': 'id',
                'sw': 'ke',
                'ta': 'in',
                'te': 'in',
                'th': 'th',
                'tl': 'ph',
                'tr': 'tr',
                'uk': 'ua',
                'ur': 'pk',
                'uz': 'uz',
                'vi': 'vn',
                'yo': 'ng',
                'zh-cn': 'cn',
                'zh-tw': 'cn',
            },
        }
    },
    computed: {
        current_language_flag() {
            const current = this.languages[this.$i18n.locale]
            return `flag fi fi-${current}`
        },
    },
    watch: {},
    methods: {
        flag_class(country) {
            return `fi fi-${country}`
        },
        flag_translation(language) {
            return this.translate(`locale.${language}`)
        },
        set_language(language) {
            setLocale(language)

            if(typeof window.OneTrust !== 'undefined') {
                window.OneTrust.changeLanguage(language)
            }
        },
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass">
.flag
    border-radius: 5px
</style>
